<template>
  <div>
    <Header></Header>
    <div class="index-body contact-body">
      <div class="banner ">
        <div class="title wrapper-box">
          <img src="../../../static/img/web_img/banner_title.png" />
        </div>
        <div class="btns">
          <router-link to="/AboutUs">About &nbsp; us</router-link>
          <router-link to="/Contact">Contact &nbsp; us</router-link>
        </div>
      </div>
      <div class="contact wrapper-box">
        <div class="title">
          <img src="../../../static/img/web_img/title_contact.png"/>
        </div>
        <div class="map">
          <img src="../../../static/img/web_img/map.png"/>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>

</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  export default {
    components: {
      Header,
      Footer
    },
    data() {
      return {}
    }
  }
</script>

<style lang="scss" scoped src="../../../static/css/enter/main.scss"></style>
<style lang="scss" scoped src="../../../static/css/enter/media.scss"></style>



// WEBPACK FOOTER //
// src/pages/web/contact.vue